import { render, staticRenderFns } from "./OpportunityPage.vue?vue&type=template&id=4f996a3f&scoped=true&"
import script from "./OpportunityPage.vue?vue&type=script&lang=js&"
export * from "./OpportunityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f996a3f",
  null
  
)

export default component.exports